import React, { useContext } from "react";
import styled from "styled-components";
import { Image } from "semantic-ui-react";

import { Column, Row } from "../../genericComponents/Layout";
import { Button } from "../../genericComponents";
import { Context } from "../../../context/globalContext";
import { NavLink } from "react-router-dom";
import { useStorage } from "../../hook/useStorage";
import { redirectToRocketDM } from '../../../helpers/utils'
import BadgesImages from "../../genericComponents/badges";

export default function UserCard(props){
  //console.log('user', props.user.membership)
  const {
    email,
    name,
    username,
    medical_school,
    year,
    about,
    specialties,
    career,
    can_offer,
    avatar,
    applicant_replicant
  } = props.user;
  const  membership = {
    type: props.user?.user_account?.membership_type
  }
  const { onConnect, handleConnectButtonPress}= props

  // console.log('conect', onConnect);
  const {
    state: { user },
  } = useContext(Context);
  const usernameSender = user.username;
  //  console.log('avatar', avatar);
  const imageAvatar = useStorage(`avatars/${avatar}`);
  return (
    <CardContainer>
       {avatar?.includes('https://')?(
        <Avatar src={avatar} size='small' circular/>
       ):
       imageAvatar ? 
        <Avatar src={imageAvatar} size='small' circular/>
      :
        <Avatar src='https://i.pinimg.com/originals/fc/0c/77/fc0c7762eae4affd716151ef68be93b6.png' size='small' circular/> 
      }
      <InfoContainer>
        <UserName to={`/home/${username}`}>{name?name:username}{' '}<BadgesImages user={{applicant_replicant, membership}}/></UserName>
        {medical_school?<UserSchool>{medical_school}</UserSchool>:null}
        <TagsContainer>
          {can_offer?.includes('MENTORSHIP')&&(
            <TagSpecial>MENTOR</TagSpecial>
          )}
          {can_offer?.includes('TUTORING')&&(
            <TagMango>TUTOR</TagMango>
          )}
          {career&&<Tag>{career}</Tag>}

          {specialties ? (
            specialties.map((tagitem, index) => (
              <Tag key={index}>{tagitem}</Tag>
            ))
          ) : null}
          {year? <Tag>{year} {year === 'Fellow'|| year=== 'Resident'?null:'Student'}</Tag>:null}
         
        </TagsContainer>
        {about?<BioSection>
          <BioTitle>Bio</BioTitle>
          <BioContent>{about}</BioContent>
        </BioSection>:null}
        
        {/* <CategoriesRow>
          {categories.map((category,index) => (
            <Category key={index}>
              <img width="15" src={category.icon} alt="" />
              <CategoryLabel>
                 {category.name} Score:{' '}
               <b>{props[category.id] ? props[category.id] : '?'}</b>
              </CategoryLabel>
            </Category>
          ))}
        </CategoriesRow> */}
      </InfoContainer>
      {/* <Location>San Francisco</Location> */}

      {(onConnect&&onConnect?.sender!=="Recommended") ? (
        onConnect.status===2?
          <MessagetButton onClick={() => redirectToRocketDM(user.email, username)}>
            Message
          </MessagetButton>
        :
          <MessagetButton>
            Pending
          </MessagetButton>
      ) : (
        <ConnectButton onClick={() => handleConnectButtonPress(onConnect, username, usernameSender, email)}>
          Connect
        </ConnectButton>
      )}
    </CardContainer>
  );
};

const CardContainer = styled.div`
  background: ${(props) => props.theme.color.softYellow};
  border-radius: 6px;
  margin-bottom: 30px;
  display: flex;
  padding: 30px;
  position: relative;
  min-width: 350px;
  width: 100%;
  @media (max-width: 920px) {
    flex-direction: column;
    font-size: 0.8em;
  }
`;

const UserName = styled(NavLink)`
  color: ${(props) => props.theme.color.darkBlue};
  font-size: 1.7em;
  font-weight: bold;
  height: 32px;
  letter-spacing: -0.1px;
  line-height: 32px;
`;

const UserSchool = styled.h3`
  color: ${(props) => props.theme.color.darkBlue};
  font-size: 1.3em;
  font-weight: bold;
  letter-spacing: -0.1px;
  margin-top: 0;
  margin-bottom: 8px;
  max-width: 400px;
`;

const InfoContainer = styled(Column)`
  width: 100%;
  margin-left: 20px;
`;

const CategoriesRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

const Category = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-right: 30px;
`;

const CategoryLabel = styled.p`
  color: ${(props) => props.theme.color.darkBlue};
  font-size: 13px;
  font-weight: 500;
  height: 24px;
  letter-spacing: 0.1px;
  margin-top: 10px;
  text-align: center;
  margin-left: 10px;
  margin-top: 5px;
`;

const Tag = styled.div`
  color: ${(props) => props.theme.color.darkBlue};
  font-size: 0.85em;
  font-weight: bold;
  height: 32px;
  letter-spacing: -0.1px;
  margin-bottom: 15px;
  background-color: ${(props) => props.theme.color.softPurple};
  padding: 5px 10px;
  text-align: center;
  border-radius: 5px;
  margin-right: 10px;
`;

const TagSpecial = styled.div`
font-size: 0.85em;
  font-weight: bold;
  height: 32px;
  letter-spacing: -0.1px;
  margin-bottom: 15px;
background-color: ${(props) => props.theme.color.gabaGreen};
padding: 5px 10px;
  text-align: center;
  border-radius: 5px;
  margin-right: 10px;
`

const TagMango = styled.div`
font-size: 0.85em;
  font-weight: bold;
  height: 32px;
  letter-spacing: -0.1px;
  margin-bottom: 15px;
background-color: #EEAA35;
padding: 5px 10px;
  text-align: center;
  border-radius: 5px;
  margin-right: 10px;
`

const TagsContainer = styled(Row)`
  flex-wrap: wrap;
`;

const Avatar = styled(Image)`&&&{
    height: 120px;
    width: 120px;
    min-width: 120px;
    @media (max-width: 920px) {
      margin-left: 16px;
      height: 80px;
      width: 80px;
      min-width: 80px;
    }
  }
`;

const ConnectButton = styled(Button)`
  position: absolute;
  right: 20px;
  top: 16px;
  background: ${(props) => props.theme.color.darkBlue};
  color: ${(props) => props.theme.color.white};
`;
const MessagetButton = styled(Button)`
  position: absolute;
  right: 20px;
  top: 16px;
  background: ${(props) => props.theme.color.softPurple};
  color: ${(props) => props.theme.color.black};
`;

const BioSection = styled.div`
  width: 100%;
`;

const BioTitle = styled.div`
  font-size: 1.2em;
  font-weight: bold;
`;
const BioContent = styled.p`
  margin-top: 5px;
  width: 100%;
`;